/**
 * @fileoverview POST handler for the "/engagement/report_dashboard/:dashboard_id/create_tile_data_query" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportDashboardDashboardIdCreateTileDataQueryCacheKeys } from "./constants";
import type {
  PostEngagementReportDashboardDashboardIdCreateTileDataQueryProps,
  EngagementReportDashboardDashboardIdCreateTileDataQueryResult,
} from "./types";

export const postEngagementReportDashboardDashboardIdCreateTileDataQuery = reactQueryMutationAdapter(
  engagementReportDashboardDashboardIdCreateTileDataQueryCacheKeys,
  (
    props: PostEngagementReportDashboardDashboardIdCreateTileDataQueryProps
  ): Promise<EngagementReportDashboardDashboardIdCreateTileDataQueryResult> => {
    return fetch(`/engagement/report_dashboard/${props.dashboardId}/create_tile_data_query`, "POST", {
      tile_id: props.tileId,
      query_builder_id: props.queryBuilderId,
    });
  }
);
